import ExpandingText from "components/ui/ExpandingText";
import Text from "hardcover-ui/components/Text";
import BookRow from "components/Bookcards/BookRow/BookRow";
import { PromptSerializersPromptBookAsAnswer } from "types/serializers";

export interface Props {
  answers: PromptSerializersPromptBookAsAnswer[];
}

export default function PromptAnswers({ answers }: Props) {
  return (
    <div className="border-t border-gray-100 dark:border-gray-600 divide-y dark:divide-gray-600 divide-gray-100">
      {answers.map((answer) => (
        <div key={`prompt-answer-${answer.id}`} className="py-4">
          <BookRow book={answer.book} size="md" />

          {answer.description?.length > 0 ? (
            <div className="mt-2 ml-20">
              <Text size="md" className="font-semibold" as="p">
                Why this book?
              </Text>
              <ExpandingText text={answer.description} lines={6} />
            </div>
          ) : (
            <></>
          )}
        </div>
      ))}
    </div>
  );
}
